<template>
  <form class="c-form-folder-update" @submit.prevent="onSubmit">
    <Form ref="form" :schema="computedSchema" v-model="currentForm" @status="saveStatus" buttonText="Update folder" :processing="processing"></Form>
    <!--     <hr />
    <button class="btn btn-danger" @click="deleteResource">Delete folder</button> -->
  </form>
</template>

<script>
import Form from './index.vue';

let schema = {
  name: {
    component: 'InputText',
    label: 'Folder name',
    description: '',
    validations: {
      required: {
        params: null,
        message: 'A folder name is required',
      },
      minLength: {
        params: 2,
        message: 'Give a descriptive name to your folder. Minimum 2 characters',
      },
      maxLength: {
        params: 54,
        message: `That's a insanely long folder name. Maximum 54 characters`,
      },
    },
  },
};

export default {
  components: {
    Form,
  },

  data: function () {
    return {
      processing: false,
      currentForm: {
        name: '',
      },
      status: null,
    };
  },

  props: {
    folder: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: '',
        };
      },
    },
  },

  computed: {
    isAdmin: function () {
      return this.$store.getters['users/isAdmin'];
    },
    computedSchema: function () {
      let s = schema;
      let user = this.user;

      if (this.isAdmin || user.id === this.currentForm.userId) {
        s.hidden = {
          component: 'InputPublicLink',
          label: 'Make this hidden?',
          description:
            "Once hidden, this folder and all boards inside it won't be accessible to your team members. The admin user can still view this folder and all boards inside this folder can still be viewed publicly if public is set to true.",
        };
      }

      return s;
    },
    user: function () {
      return this.$store.getters['users/user'];
    },
    schema: function () {
      let s = schema;

      return s;
    },
  },

  methods: {
    async deleteResource() {
      await this.$store.dispatch('folders/remove', this.form.id);
      this.$emit('onSubmit');
      this.$router.replace({ path: '/' });
    },
    saveStatus: function (saveStatus) {
      this.status = saveStatus;
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (this.status.invalid) {
        return;
      }

      this.processing = true;

      let form = this.currentForm;

      form = {
        ...form,
      };

      delete form.shareable;
      delete form.createdAt;
      delete form.slug;
      delete form.userId;
      delete form.workspaceId;
      delete form._count;

      let response = await this.$store.dispatch('folders/update', form);
      this.$emit('onSubmit');
      this.processing = false;
    },
  },

  created: function () {
    this.currentForm = this.folder;
  },
};
</script>

<style></style>
